import Swiper, {
  EffectCreative,
  Navigation,
  Controller,
  Autoplay,
} from 'swiper';

class InsightsHeroSlider {
  constructor(el) {
    this.el = el;
    Swiper.use([EffectCreative, Navigation, Controller, Autoplay]);

    this.initSlider();
  }
  initSlider() {
    this.swiperContent = new Swiper(this.el.querySelector('.swiper--content'), {
      effect: 'creative',
      speed: 500,
      loop: true,
      loopAdditionalSlides: 5,
      watchSlidesProgress: true,
      creativeEffect: {
        prev: {
          opacity: 0,
        },
        next: {
          opacity: 0,
        },
      },
    });
    const swiperImages = this.el.querySelector('.swiper--images');
    const delay = swiperImages.dataset.autoPlayDelay;
    const autoplay = delay ? { delay } : undefined;

    this.swiper = new Swiper(this.el.querySelector('.swiper--images'), {
      effect: 'creative',
      speed: 500,
      loop: true,
      loopAdditionalSlides: 5,
      creativeEffect: {
        limitProgress: 5,
        prev: {
          translate: ['-100%', 0, 0],
          opacity: 0,
        },
        next: {
          translate: ['12.5%', 0, -136],
          opacity: 0.6,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      controller: {
        control: this.swiperContent,
      },
      autoplay,
    });
  }
}

export default InsightsHeroSlider;
